import { View } from 'react-native';
import styled from 'styled-components/native';

export default styled(View)`
  justify-content: center;
  align-items: flex-start;
  margin-bottom: 5px;
`;
